module.exports = function() {
  return new Worker(__webpack_public_path__ + "65fc17f03584647d9c70.worker.js");
};

if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
